(function () {
  var excludedHandles = {
    'embudo-de-arena-para-castillos': true,
    'cubo-plegable-de-playa': true,
    'boya-flotante-para-llaves': true,
    'ancla-rosca-para-sombrilla-de-playa': true,
    'caja-para-cartas-de-truco': true,
    'pack-mundialista-totesti-2026': true
  };
  var specialPromoHandles = {
    'monstera-totesti-planta-decorativa-6-posavasos': 'Nuevo lanzamiento',
    'kit-sensorial-totesti-4-fidgets-articulados': 'Nuevo lanzamiento',
    'juego-de-playa-tejo-argentino': 'Precio lanzamiento',
    'bowl-pelota-con-divisor-y-porta-lata-totesti': 'Promo especial -30%'
  };

  function parseFallbackProducts(section) {
    var script = section.querySelector('[data-totesti-bestsellers-fallback]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function cleanTitle(title) {
    return String(title || '').replace(/\s*\|\s*Totesti\s*$/i, '').trim();
  }

  function moneyFromProduct(product) {
    var variant = product.variants && product.variants[0];
    if (!variant || !variant.price) return '';

    var amount = Number.parseFloat(variant.price);
    if (Number.isNaN(amount)) return variant.price;

    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  function moneyFromAmount(amount) {
    var parsedAmount = Number.parseFloat(amount);
    if (Number.isNaN(parsedAmount)) return amount || '';

    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(parsedAmount);
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function normalizeProduct(product) {
    var image = product.image || (product.images && product.images[0] && product.images[0].src);
    var variant = product.variants && product.variants[0];

    return {
      title: cleanTitle(product.title),
      handle: product.handle,
      url: product.url || '/products/' + product.handle,
      image: image || null,
      price: product.price || moneyFromProduct(product),
      compareAtPrice: product.compare_at_price || (variant && variant.compare_at_price ? moneyFromAmount(variant.compare_at_price) : ''),
      available: product.available !== false && (!variant || variant.available !== false),
      tags: product.tags || []
    };
  }

  function shouldShow(product) {
    var tags = Array.isArray(product.tags) ? product.tags.join(' ').toLowerCase() : String(product.tags || '').toLowerCase();
    return product.handle && !excludedHandles[product.handle] && product.available !== false && !/(borrador|no publicar|licencia pendiente)/.test(tags);
  }

  function uniqueByHandle(products) {
    var seen = {};
    return products.filter(function (product) {
      if (!product.handle || seen[product.handle]) return false;
      seen[product.handle] = true;
      return true;
    });
  }

  function productCard(product) {
    var item = document.createElement('div');
    item.className = 'totesti-products-carousel__item totesti-bestseller-card';
    item.setAttribute('role', 'listitem');
    item.dataset.productHandle = product.handle;

    var title = escapeHTML(product.title);
    var price = escapeHTML(product.price);
    var compareAtPrice = escapeHTML(product.compareAtPrice);
    var promoBadge = specialPromoHandles[product.handle]
      ? '<span class="totesti-promo-badge">' + escapeHTML(specialPromoHandles[product.handle]) + '</span>'
      : '';
    var priceMarkup = compareAtPrice && compareAtPrice !== price
      ? '<span class="totesti-bestseller-card__price"><s>' + compareAtPrice + '</s><strong>' + price + '</strong></span>'
      : '<span class="totesti-bestseller-card__price">' + price + '</span>';
    var url = encodeURI(product.url);
    var media = product.image
      ? '<img src="' + encodeURI(product.image) + '" alt="' + title + '" loading="lazy">'
      : '<div class="totesti-bestseller-card__placeholder" aria-hidden="true"></div>';

    item.innerHTML =
      '<a class="totesti-bestseller-card__link" href="' + url + '">' +
        '<span class="totesti-bestseller-card__media">' + media + promoBadge + '</span>' +
        '<span class="totesti-bestseller-card__content">' +
          '<span class="totesti-bestseller-card__title">' + title + '</span>' +
          priceMarkup +
        '</span>' +
      '</a>';

    return item;
  }

  function renderProducts(carousel, products) {
    carousel.replaceChildren.apply(carousel, products.map(productCard));
  }

  function setupButtons(section, carousel) {
    var prev = section.querySelector('[data-totesti-bestsellers-prev]');
    var next = section.querySelector('[data-totesti-bestsellers-next]');
    var getStep = function () {
      var item = carousel.querySelector('.totesti-products-carousel__item');
      return item ? item.getBoundingClientRect().width + 24 : carousel.clientWidth;
    };

    if (prev) {
      prev.addEventListener('click', function () {
        carousel.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        carousel.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }
  }

  async function hydrateBestsellers(section) {
    var carousel = section.querySelector('[data-totesti-bestsellers]');
    if (!carousel) return;

    setupButtons(section, carousel);

    var fallbackProducts = parseFallbackProducts(section).map(normalizeProduct).filter(shouldShow);
    var sourceUrl = carousel.dataset.sourceUrl;
    if (!sourceUrl) return;

    try {
      var response = await fetch(sourceUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;

      var data = await response.json();
      var bestsellers = uniqueByHandle((data.products || []).map(normalizeProduct).filter(shouldShow));
      var products = uniqueByHandle(fallbackProducts.concat(bestsellers));

      if (products.length > 0) {
        renderProducts(carousel, products.slice(0, 12));
      }
    } catch (error) {
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.totesti-bestsellers').forEach(hydrateBestsellers);
  });
})();
